module.exports = __webpack_public_path__ + "static/media/apiResful2.fbb0cfbc.png";